module.exports = __webpack_public_path__ + "img/other_grey_al.b38248fc.svg";